export function resetClaims() {
  return {
    type: 'RESET_CLAIMS'
  }
}

export function setDisclaimer(show) {
  return {
    type: 'SET_DISCLAIMER',
    payload: { show }
  }
}

export function getDateTimeDisplay(date, time) {
  return date && time ? (date.format('ddd, MMM D, YYYY') + ' at ' + time.format('HH:mm A')) : null
}